import {
	FETCH_ADMINS_REQUEST,
	FETCH_ADMINS_SUCCESS,
	FETCH_ADMINS_FAIL,
	UPDATE_ADMIN_REQUEST,
	UPDATE_ADMIN_SUCCESS,
	UPDATE_ADMIN_FAIL,
	FETCH_ADMIN_REQUEST,
	FETCH_ADMIN_SUCCESS,
	FETCH_ADMIN_FAIL,
	CREATE_ADMIN_REQUEST,
	CREATE_ADMIN_SUCCESS,
	CREATE_ADMIN_FAIL,
	DELETE_ADMIN_REQUEST,
	DELETE_ADMIN_SUCCESS,
	DELETE_ADMIN_FAIL,
} from "../constants/admin";

function fetchAdminsReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			error: null,
			adminDeleted: false,
		};
	}
	switch (action.type) {
		case FETCH_ADMINS_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_ADMINS_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				admins: action.payload,
			};
		case FETCH_ADMINS_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

function updateAdminReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}
	switch (action.type) {
		case UPDATE_ADMIN_REQUEST:
			return { loading: true };
		case UPDATE_ADMIN_SUCCESS:
			return {
				loading: false,
				status: "SUCCEEDED",
			};
		case UPDATE_ADMIN_FAIL:
			return { loading: false, status: "FAILED" };
		default:
			return state;
	}
}

function fetchAdminReducer(state, action) {
	if (typeof state === "undefined") {
		state = { status: "IDLE", error: null };
	}
	switch (action.type) {
		case FETCH_ADMIN_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_ADMIN_SUCCESS:
			return {
				loading: false,
				status: "SUCCEEDED",
				admin: action.payload,
			};
		case FETCH_ADMIN_FAIL:
			return { loading: false, status: "FAILED" };
		default:
			return state;
	}
}

function createAdminReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}
	switch (action.type) {
		case CREATE_ADMIN_REQUEST:
			return { loading: true };
		case CREATE_ADMIN_SUCCESS:
			return { loading: false, success: true, admin: action.payload };
		case CREATE_ADMIN_FAIL:
			return { loading: false, success: false, error: action.payload };
		default:
			return state;
	}
}

function deleteAdminReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}
	switch (action.type) {
		case DELETE_ADMIN_REQUEST:
			return { loading: true };
		case DELETE_ADMIN_SUCCESS:
			return {
				loading: false,
				adminDeleted: true,
			};
		case DELETE_ADMIN_FAIL:
			return { loading: false, adminDeleted: false, error: action.payload };
		default:
			return state;
	}
}

export {
	fetchAdminsReducer,
	updateAdminReducer,
	fetchAdminReducer,
	createAdminReducer,
	deleteAdminReducer,
};
